/**
 * Shared list of event categories.
 * Used for: event creation (category), student registration & profile (interests).
 * Must match backend Event model category enum.
 */
export const EVENT_CATEGORIES = [
  "AI",
  "Technical",
  "Cultural",
  "Sports",
  "Workshop",
  "Seminar",
  "Competition",
  "Other",
];
